import { render } from "./SelTelur.vue?vue&type=template&id=00888005"
import script from "./SelTelur.vue?vue&type=script&lang=js"
export * from "./SelTelur.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/aims/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__